'use client';

import { Children, cloneElement } from 'react';

import { usePopperContext } from './hooks';

import type { FC, ReactElement } from 'react';

export interface ToggleProps {
  children: ReactElement | ReactElement[];
}

export const PopperHoverEnter: FC<ToggleProps> = ({ children, ...props }) => {
  const { handleOpen } = usePopperContext();

  return (
    <>
      {Children.map( children, (child) =>
        cloneElement( child, {
          onMouseEnter: handleOpen,
          ...props,
        } ) )}
    </>
  );
};
